import React, { useLayoutEffect, useRef } from 'react';
import './Header.css';
import gsap from 'gsap';
import heartImg from '../../asserts/heart.png';
import panelImg from '../../asserts/panel.png';
import coinImg from '../../asserts/coin.png';
import pauseImg from '../../asserts/pause.png';

const Header = ({ mode = 'default', onPause }) => {
  const headerRef = useRef();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.set('.header-left', { x: -120, opacity: 0 });
      gsap.set('.header-right-item', { y: -80, opacity: 0, rotation: -15 });

      const tl = gsap.timeline();
      tl.to('.header-left', {
        x: 0, opacity: 1, duration: 1, ease: 'power3.out',
      }).to('.header-right-item', {
        y: 0, opacity: 1, rotation: 0, duration: 0.8,
        stagger: 0.15, ease: 'back.out(2)',
      }, '-=0.7');

      gsap.to('.header-heart', {
        scale: 1.08, duration: 0.5, repeat: -1,
        yoyo: true, ease: 'power1.inOut', delay: 1.2,
      });

      if (mode === 'default') {
        gsap.to('.coin-box img', {
          rotation: 25, duration: 1.8, repeat: -1,
          yoyo: true, ease: 'sine.inOut', stagger: 0.5, delay: 1.5,
        });
      }
    }, headerRef);

    return () => ctx.revert();
  }, [mode]);

  return (
    <div className="header" ref={headerRef}>
      <div className="header-left">
        <img src={heartImg} alt="" className="header-heart" />
        <img src={panelImg} alt="" className="header-panel" />
      </div>
      <div className="header-right">
        {mode === 'default' ? (
          <>
            <div className="coin-box header-right-item"><img src={coinImg} alt="" /></div>
            <div className="coin-box header-right-item"><img src={coinImg} alt="" /></div>
            <div className="coin-box header-right-item"><img src={coinImg} alt="" /></div>
          </>
        ) : (
          <div className="pause-btn header-right-item" onClick={onPause}>
            <img src={pauseImg} alt="pause" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;